import { FC, useState } from "react";

import { getLateSubmissionDueDate, intervalIsDefined, isInLateSubmissionWindow } from "../helpers";

import { formatLocalePattern } from "i18n/helpers";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { PageTabVariant } from "providers/DocViewProvider";
import { useAppSelector } from "store";
import { pageSelectors } from "store/selectors";

export type LateSubmissionAvailableBannerProps = {
  pageId: string;
  selectedTabVariant?: PageTabVariant;
};

export const LateSubmissionAvailableBanner: FC<LateSubmissionAvailableBannerProps> = ({
  pageId,
  selectedTabVariant,
}) => {
  // TODO: we could compute isInLateSubmissionWindow without the entire page object
  // eslint-disable-next-line @minervaproject/no-object-from-use-app-selector/no-object-from-use-app-selector
  const page = useAppSelector((s) => pageSelectors.selectById(s, pageId));
  const lateSubmissionDate =
    page &&
    page.due_at &&
    page.late_submission_interval &&
    intervalIsDefined(page.late_submission_interval)
      ? formatLocalePattern(getLateSubmissionDueDate(page) as Date, "common.formats.month_day_time")
      : undefined;
  const [showBanner, setShowBanner] = useState(true);
  const submissionKey = lateSubmissionDate ? "date" : "indefinite";
  const isDraftTab =
    selectedTabVariant && ["my_draft", "class_draft", "page_content"].includes(selectedTabVariant);

  const showLateSubmissionAvailableBanner = isDraftTab && isInLateSubmissionWindow(page);

  if (!showLateSubmissionAvailableBanner) {
    return null;
  }

  return showBanner ? (
    <Banner className="page-block-width" kind="warning" onDismiss={() => setShowBanner(false)}>
      {t(`warning.allowing_late_submissions_${submissionKey}`, { date: lateSubmissionDate })}
    </Banner>
  ) : null;
};
